type JwtPayload = {
  exp?: unknown;
};

const base64UrlDecode = (segment: string): string => {
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  return atob(base64 + padding);
};

/**
 * Returns the `exp` claim (seconds since epoch) of a JWT, or undefined when
 * the token is not a decodable JWT with a numeric `exp`.
 */
export const getJwtExpiry = (token: string): number | undefined => {
  try {
    const payload: JwtPayload = JSON.parse(
      base64UrlDecode(token.split(".")[1])
    );
    return typeof payload.exp === "number" ? payload.exp : undefined;
  } catch {
    return undefined;
  }
};

/**
 * True only when the token is a JWT whose `exp` has passed. Tokens that
 * cannot be decoded (e.g. the placeholder token used by local offline logins,
 * or opaque refresh tokens) are never reported as expired.
 */
export const isJwtExpired = (token: string | undefined | null): boolean => {
  if (!token) {
    return false;
  }
  const expiry = getJwtExpiry(token);
  return expiry !== undefined && expiry * 1000 < Date.now();
};
